const NumberPadButton = ({ title, onClick }) => {
  return (
    <di className="number-pad__button" onClick={onClick}>
      <div className="number-pad__button_text">{title}</div>
    </di>
  );
};

export default NumberPadButton;
